<template>
    <div class="mt-2">
        <h4>Other user's responses</h4>
        <transition name="fade">
            <div v-if="veracityResponses.length > 0">
                <p>See how other users rated the veracity of this rumour:</p>

                <div v-for="vResponse in veracityResponses" class="media mb-3 pr-3 pt-3 border rounded">
                    <img src="/static/images/user.png" width="30" class="m-3"/>
                    <div class="media-body">

                        <div class="mb-2"><strong>{{ vResponse.username }}</strong> - {{ vResponse.date }}</div>

                        <p>
                            <strong>Provided veracity rating:</strong>
                        </p>
                        <div class="row">
                            <div class="col-4 text-left">False</div>
                            <div class="col-4 text-center">Unverified</div>
                            <div class="col-4 text-right">True</div>
                        </div>
                        <input type="range" class="slider mb-3" min="-1" max="1" :value="vResponse.veracity"
                               step="0.01"
                               data-toggle="tooltip" data-html="true" data-placement="bottom" disabled/>

                        <div class="mb-2">
                            <strong>Evidence for the rating:</strong>
                            <p>{{ vResponse.evidence }}</p>
                        </div>
                    </div>

                </div>
            </div>
            <div v-else>
                No user responses to this tweet.
            </div>
        </transition>
    </div>
</template>

<script>
    import { mapState, mapGetters} from 'vuex'
    export default {
        name: "TweetVeracityResponses",
        computed: {
            ...mapState(["veracityResponses"]),
        }
    }
</script>

<style scoped>

</style>
